// Languages from Learning Service: https://classes.apiabroad.app/api/v2/docs#/Languages
import { learningServiceRequest, skip} from "./utils";
const languagesService = {
  async list(limit = 18, page = 1, q = "", extraParams = {}) {
    const { data: response } = await learningServiceRequest({
      method: "get",
      url: "/languages/",
      params: {
        limit,
        skip: skip(page, limit),
        q,
        ...extraParams,
      },
      failureMessage: "Error loading languages data",
    });
    return response?.data?.items ?? [];
  },
};
export default languagesService;
